import React, { useState, useCallback } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import { Box, Stepper, Step, StepLabel, styled, Typography } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { IcoAggregate, IcoClose, Trash } from '@icons';
import {
	getProjects,
	createProjectAggregate,
	// , manageProjectsToAggregate
} from '@lib/api';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import StatusBar from '@components/StatusBar';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import { translate } from 'components/translation/translation';

const CustomConnector = styled(StepConnector)(({ theme }) => ({
	[`& .${stepConnectorClasses.line}`]: {
		minHeight: '40px',
		borderWidth: '3px',
	},
	[`&.Mui-active .${stepConnectorClasses.line}, &.Mui-completed .${stepConnectorClasses.line}`]: {
		borderColor: '#06797F',
		borderWidth: '3px',
	},
}));

const CustomStepIconRoot = styled('div')(({ theme, ownerState }) => ({
	backgroundColor:
		ownerState.active || ownerState.completed
			? // '#06797F'
				'var(--np-primary-color)'
			: theme.palette.grey[300],
	color: ownerState.active || ownerState.completed ? '#fff' : theme.palette.grey[700],
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	borderRadius: '50%',
	width: 26,
	height: 26,
	fontWeight: 600,
	fontSize: 13,
}));

function CustomStepIcon(props) {
	const { active, completed, icon } = props;
	const displayIcon = icon === 4 ? icon - 1 : icon;

	return <CustomStepIconRoot ownerState={{ active, completed }}>{displayIcon}</CustomStepIconRoot>;
}

const initialState = {
	name: '', //obbl
	description: '',
	public: null, //obbl
	notes: '',
};

const ProjectAggregateButton = () => {
	const [aggregate, setAggregate] = useState(initialState);
	const [activeStep, setActiveStep] = useState(0);
	const [aggregateTypeChoice, setAggregateTypeChoice] = useState('');
	const [selectedEntity, setSelectedEntity] = useState(0);
	const [selectedProjects, setSelectedProjects] = useState([]);
	const [hasAutoSelected, setHasAutoSelected] = useState(false);
	const [showModalAggregatesProject, setShowModaAggregateslProject] = useState(false);
	const [sbShow, setSbShow] = useState(<></>);
	const isSubstep = (aggregateTypeChoice === 'notice' || aggregateTypeChoice === 'company') && activeStep === 2;
	const queryClient = useQueryClient();
	//console.log('aggregateTypeChoice', aggregateTypeChoice);
	//console.log('activeStep', activeStep);
	//console.log('selectedEntity1:', selectedEntity);
	//console.log('aggregate', aggregate);
	//console.log('selectedProjects', selectedProjects);

	const handleShowModal = (setShowModal) => setShowModal(true);

	const handleCloseModal = (setShowModal) => {
		setSbShow(<></>);
		setShowModal(false);
		setAggregate(initialState);
		setActiveStep(0);
		setAggregateTypeChoice('');
		setSelectedEntity(0);
		setSelectedProjects([]);
	};

	const handleStatusBar = useCallback((status, message, timeout) => {
		setSbShow(<StatusBar status={status} message={message} timeout={timeout} />);
	}, []);

	const isNoticeOrBeneficiary = aggregateTypeChoice === 'notice' || aggregateTypeChoice === 'company';

	let steps = [
		{ label: 'Informazioni base', type: 'step', virtualIndex: 0 },
		{ label: 'Tipologia', type: 'step', virtualIndex: 1 },
		...(isNoticeOrBeneficiary ? [{ label: 'Selezione progetti', type: 'substep', virtualIndex: 2 }] : []),
		{ label: 'Riepilogo', type: 'step', virtualIndex: isNoticeOrBeneficiary ? 3 : 2 },
	];

	const queryParam = '?perPage=false';

	const { data: clearedProjectsNoPagination, isPending } = useQuery({
		queryKey: ['projects', queryParam],
		queryFn: async () => {
			const response = await getProjects(queryParam, 'projects');
			let clearedProjects = [];

			if (response.success) {
				clearedProjects = response.data.map((project) => ({
					id: project.id,
					name: project.name,
					cup: project.cup,
					totalAmount: project.totalAmount,
					notice: { id: project.noticeId, call: project.notice.call, name: project.notice.name },
					company: { id: project.companyId, name: project.company.name, code: project.company.code },
					startDate: project.startDate ?? project.forecastStartDate,
				}));
			} else {
				throw new Error(response.message);
			}

			return clearedProjects;
		},
		enabled: showModalAggregatesProject && aggregateTypeChoice !== '',
		onError: (error) => {
			handleStatusBar('error', error.message, false);
		},
	});

	const onChange = (e, fieldName) => {
		//console.log('e', e);
		let tempAggregate = { ...aggregate };
		let value;

		switch (fieldName) {
			case 'name':
			case 'description':
				value = e.target.value;
				break;
			case 'public':
				value = e;
				break;
			default:
				break;
		}

		tempAggregate[fieldName] = value;

		setAggregate(tempAggregate);
	};

	const disableStepButton = () => {
		if (activeStep === 0) {
			//step 1: info base
			return !(aggregate.name.trim() !== '' && aggregate.public !== null);
		}

		if (activeStep === 1) {
			if (aggregateTypeChoice === 'cup' && selectedProjects.length === 0) {
				//step 2: cup
				return true;
			}
			if (aggregateTypeChoice !== 'cup' && selectedEntity === 0) {
				//step 2: notice o company
				return true;
			}
		}

		if (activeStep === 2 && isSubstep && selectedProjects.length === 0) {
			//step 2 substep: selezione progetti substep
			return true;
		}

		return false;
	};

	const useCreateProjectAggregate = (options = {}) => {
		return useMutation({
			mutationFn: (aggregate) => createProjectAggregate(aggregate),
			...options,
		});
	};
	const { mutateAsync: saveAggregate, isPending: isPending1 } = useCreateProjectAggregate();

	// const useManageProjectsToAggregate = (options = {}) => {
	// 	return useMutation({
	// 		mutationFn: (aggregate) => manageProjectsToAggregate(aggregate),
	// 		...options,
	// 	});
	// };
	// const { mutateAsync: mutateManageProjectsToAggregate, isPending: isPending2 } = useManageProjectsToAggregate();

	const handleSaveAggregates = async (e) => {
		e?.preventDefault();
		setSbShow(<></>);

		aggregate.projectIds = selectedProjects;

		const result = await saveAggregate(aggregate);
		//console.log('result', result);

		if (result.success) {
			// const data = { projectIds: selectedProjects };

			// const resp = await mutateManageProjectsToAggregate({ aggregateId: result.data?.id, action: 'add', data });
			// //console.log('resp', resp);

			// if (resp.success) {
			handleStatusBar('success', translate('common.message.edited', 'Elemento modificato con successo'), true);

			setTimeout(() => {
				setShowModaAggregateslProject(false);
				queryClient.invalidateQueries({ queryKey: ['projectsAggregate'] });
			}, 2500);
			// } else {
			// 	handleStatusBar('error', "Errore nell'aggiunta dei progetti all'aggregato", false);
			// }
		} else {
			handleStatusBar(
				'error',
				result.success === false
					? Object.values(result.data).join()
					: translate('common.error.save', 'Si è verificato un errore durante il salvataggio delle informazioni'),
				false,
			);
		}
	};

	const MyCustomStepIcon = (props) => <CustomStepIcon {...props} />;

	return (
		<>
			<Button
				onClick={() => handleShowModal(setShowModaAggregateslProject)}
				className="btn new custom-outline-button me-2"
				style={{
					height: '48px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					minWidth: '226px',
				}}
			>
				<IcoAggregate
					// className="ico-path-fill-primary"
					width="23"
				/>
				<span className="d-md-inline">Crea Gruppo</span>
			</Button>

			<Modal
				show={showModalAggregatesProject}
				onHide={() => handleCloseModal(setShowModaAggregateslProject)}
				fullscreen
				centered
				className="creation-modal-aggregates"
				enforceFocus={false}
				autoFocus={false}
			>
				<Modal.Body className="py-0 overflow-hidden">
					<Row className="h-100">
						<Col className="col-1 offcanvas-modal-aggregates">
							<Box className="py-5">
								<Stepper activeStep={activeStep} orientation="vertical" connector={<CustomConnector />}>
									{steps.map((step, index) =>
										step.type === 'step' ? (
											<Step key={`${step.type}-${step.virtualIndex}`} completed={activeStep > index} active={activeStep === index}>
												<StepLabel StepIconComponent={MyCustomStepIcon}>
													<Typography
														sx={{
															fontWeight: activeStep >= index ? '700' : '400',
															color: activeStep >= index ? 'text.primary' : 'text.secondary',
														}}
													>
														{step.label}
													</Typography>
												</StepLabel>
											</Step>
										) : (
											<Step key={`${step.type}-${step.virtualIndex}`} className="substep_container">
												<Box
													key={`${step.type}-${step.virtualIndex}`}
													sx={{
														pl: 4,
														py: 1,
														fontSize: '0.9rem',
														marginTop: '-2.5rem',
														// position: 'absolute',
														// top: '9.5rem',
													}}
												>
													<span
														className="substep-circle"
														style={{
															display: 'inline-block',
															width: 12,
															height: 12,
															borderRadius: '50%',
															marginRight: 10,
															backgroundColor:
																activeStep === step.virtualIndex || activeStep === step.virtualIndex + 1 ? '#06797F' : '#E3E7EB',
															border: '2px solid #E3E7EB',
														}}
													/>
													<span
														style={{
															fontWeight: activeStep === step.virtualIndex || activeStep === step.virtualIndex + 1 ? '700' : '400',
															color:
																activeStep === step.virtualIndex || activeStep === step.virtualIndex + 1
																	? 'text.primary'
																	: 'text.secondary',
														}}
													>
														{step.label}
													</span>
												</Box>
											</Step>
										),
									)}
								</Stepper>
							</Box>
						</Col>

						<Col className="content-modal-aggregates">
							<Row className="align-items-center mb-4 pe-3">
								<Col className="">
									<span className="new-h2">Creazione gruppo</span>
								</Col>

								<Col
									className="col-auto ms-auto d-flex align-items-center new-text-as-link text-end text-uppercase"
									style={{ cursor: 'pointer', userSelect: 'none' }}
									onClick={() => handleCloseModal(setShowModaAggregateslProject)}
								>
									<span>annulla</span>
									<IcoClose className="ico-path-fill-second-color ms-2" width="16" style={{ marginTop: '2px' }} />
								</Col>
							</Row>

							<Row className="pe-3">
								<span as={Col} className="col-10" style={{ lineHeight: '28px' }}>
									La funzionalità consente di creare aggregati di progetto per agevolare le attività operative e il monitoraggio
									trasversale. L'utente può selezionare e raggruppare più progetti applicando filtri dedicati, così da ottenere una vista
									unificata e coerente rispetto alle proprie esigenze di analisi e gestione.
								</span>
							</Row>

							<div style={{ paddingLeft: 0, margin: 0, maxWidth: '100%' }}>
								{/* CONTENUTO MODALE CHE CAMBIA IN BASE ALLO STEP */}
								{activeStep === 0 ? <StepOne aggregate={aggregate} onChange={onChange} /> : null}

								{activeStep === 1 || (activeStep === 2 && isSubstep) ? (
									<StepTwo
										aggregate={aggregate}
										setAggregate={setAggregate}
										activeStep={activeStep}
										clearedProjectsNoPagination={clearedProjectsNoPagination}
										isPending={isPending}
										selectedProjects={selectedProjects}
										selectedEntity={selectedEntity}
										setSelectedEntity={setSelectedEntity}
										setSelectedProjects={setSelectedProjects}
										aggregateTypeChoice={aggregateTypeChoice}
										setAggregateTypeChoice={setAggregateTypeChoice}
										hasAutoSelected={hasAutoSelected}
										setHasAutoSelected={setHasAutoSelected}
										isSubstep={isSubstep}
									/>
								) : null}

								{(activeStep === 2 && !isSubstep) || activeStep === 3 ? (
									<StepThree aggregate={aggregate} projects={clearedProjectsNoPagination} selectedProjects={selectedProjects} />
								) : null}
							</div>
						</Col>
					</Row>

					{sbShow}
				</Modal.Body>
				<Modal.Footer className="footer-shadow">
					<Button
						onClick={() => {
							setAggregate(initialState);
							setActiveStep(0);
							setAggregateTypeChoice('');
							setSelectedEntity(0);
							setSelectedProjects([]);
						}}
						className="btn custom-ghost-button d-flex align-items-center"
						style={{ gap: '0.5rem', color: '#CC334C' }}
					>
						<Trash style={{ fill: '#CC334C' }} width={17.5} />
						<span style={{ fontWeight: '500' }}>Resetta tutto</span>
					</Button>

					<Box sx={{ flex: '1 1 auto' }} />

					{activeStep > 0 ? (
						<Button
							className="btn custom-outline-button d-flex justify-content-center align-items-center"
							onClick={() => {
								setActiveStep((prev) => Math.max(prev - 1, 0));
							}}
							style={{
								width: '285px',
								fontWeight: 500,
								fontSize: '18px',
								lineHeight: '28px',
							}}
						>
							Indietro
						</Button>
					) : null}
					<Button
						className="btn custom-primary-button d-flex justify-content-center align-items-center gap-2"
						style={{
							width: '285px',
							fontWeight: 500,
							fontSize: '18px',
							lineHeight: '28px',
						}}
						onClick={() => {
							activeStep === steps.length - 1 ? handleSaveAggregates() : setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
						}}
						disabled={disableStepButton()}
					>
						{activeStep === steps.length - 1 ? 'Conferma e crea gruppo' : 'Avanti'}
						{isPending1 ? (
							// || isPending2
							<span className="spinner-border spinner-border-sm ms-2" size="sm" role="status" aria-hidden="true"></span>
						) : null}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};
export default ProjectAggregateButton;
